import * as Yup from "yup";
import { regexList } from "../../Constants";
import { MultiTags } from "../../components/formHelpers/FormMultiInputTags";
export const RegisterContents = {
  labels: {
    heading: "Register Here",
    email: "Email ID",
    loading: "Loading",
    verified: "Verified",
    understandTerms: "I understand the ",
    terms: "Terms and conditions",
    name: "Full Name as per PAN",
    gender: "Title",
    gstin: "Gstin of the Company",
    phoneNumber: "Mobile number",
    alreadyRegistered: "Already registered? ",
    reportIssue: "Report Issue?"
  },
  placeholders: {
    name: "Enter Full Name",
    gstin: "Enter GSTIN of the company you can also add more",
    phoneNumber: "Enter Phone number",
    email: "Enter email ID"
  },
  feedbacks: {
    registrationNoAccess: "No Access to registration page when loggedIn"
  },
  buttons: {
    register: "Register Now",
    logIn: "Log In"
  }
};
const errorMessages = {
  invalid: "Invalid format",
  invalidGstin: "Enter a valid Gstin",
  invalidPhoneNumber: "Enter a valid Phone Number",
  invalidEmail: "Enter a valid Email",
  captchaNotVerified: "Captcha not verified",
  duplicateGstin: "Duplicate gstin entered",
  noValidGstin: "Enter at least one valid gstin",
  noGstin: "Enter at least one gstin",
  termNotAgreed: "T&C not agreed",
  required: "Required"
};

export const RegistrationValidationSchema = Yup.object().shape({
  gstinValidate: Yup.string()
    .uppercase()
    .matches(regexList.gstin, errorMessages.invalidGstin)
    .test({
      name: "Duplicate GSTIN check",
      test(value) {
        return this.parent.gstinValidityList
          .filter((item: MultiTags) => !item.removed)
          .find((item: MultiTags) => item.value === value)
          ? this.createError({
              message: errorMessages.duplicateGstin
            })
          : true;
      }
    }),
  email: Yup.string()
    .email(errorMessages.invalidEmail)
    .required(errorMessages.required),
  phoneNumber: Yup.string()
    .matches(regexList.phoneNumber, errorMessages.invalidPhoneNumber)
    .required(errorMessages.required),
  name: Yup.string()
    .required(errorMessages.required)
    .matches(regexList.minimum1Character, errorMessages.invalid),
  gender: Yup.string().required(errorMessages.required),
  isVerified: Yup.boolean().oneOf([true], errorMessages.captchaNotVerified),
  terms: Yup.boolean().oneOf([true], errorMessages.termNotAgreed),
  gstinValidityList: Yup.mixed().test(
    "valid gstins",
    errorMessages.noGstin,
    function(this, values: MultiTags[]) {
      const gstins = values
        .filter(item => !item.error && !item.removed)
        .map(item => item.value);
      return !!gstins.length;
    }
  )
});

export enum GenderType {
  male = "M",
  female = "F",
  others = "O"
}

//Options for title dropdown.
export const genderOptions = {
  Mr: GenderType.male,
  "Miss/Mrs": GenderType.female,
  Mx: GenderType.others
};
